import styled from "styled-components";

const ContainerWrapper = styled.div`
  border-bottom: 1px solid #000;
  padding: 0.25rem;
`;

export default ContainerWrapper;
